"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const filter_1 = __importDefault(require("lodash/filter"));
const find_1 = __importDefault(require("lodash/find"));
const get_1 = __importDefault(require("lodash/get"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const map_1 = __importDefault(require("lodash/map"));
const size_1 = __importDefault(require("lodash/size"));
const mobx_1 = require("mobx");
const getExtensionPaymentMethods_1 = __importDefault(require("../../clients/booking/paymentMethods/getExtensionPaymentMethods"));
const getPaymentMethods_1 = __importDefault(require("../../clients/booking/paymentMethods/getPaymentMethods"));
const API_STATE_1 = __importDefault(require("../../constants/app/API_STATE"));
const PAYMENT_METHOD_TYPE_1 = __importDefault(require("../../constants/payment/PAYMENT_METHOD_TYPE"));
const paymentMethodFactory_1 = __importDefault(require("../../factories/booking/paymentMethodFactory"));
const paymentMethod_mock_1 = require("../../mocks/booking/paymentMethod.mock");
const mapInitialStateToStoreState_1 = __importDefault(require("../../utils/store/mapInitialStateToStoreState"));
/**
 * Payment Method Domain Store
 * Stores a list of payment method.
 */
class PaymentMethodStore {
    // @observable errorData: ErrorDataType = {} as ErrorDataType;
    constructor(initialState, $env) {
        this.data = [];
        this.apiState = API_STATE_1.default.INITIAL;
        /**
         * Fetches Payment method data from backend
         * @param endPoint {string}
         * @param errorHandler {function}
         */
        this.fetch = (0, mobx_1.flow)(function* (quoteId, errorHandler) {
            try {
                this.apiState = API_STATE_1.default.LOADING;
                this.data = [];
                // this.errorData = {};
                // make the api call
                const response = yield (0, getPaymentMethods_1.default)(quoteId);
                const hasData = !(0, isEmpty_1.default)(response); // response comes as array
                // if api response have data
                if (hasData) {
                    this.onSuccess(response);
                }
                else {
                    // return all options if api responds with empty data
                    this.onSuccess(paymentMethod_mock_1.mockData);
                }
            }
            catch (err) {
                // return all options if api gives error with non 200 status code
                this.onSuccess(paymentMethod_mock_1.mockData);
                this.callErrorHandler(err, errorHandler);
            }
        });
        /**
         * Fetches Payment method data from backend
         * @param endPoint {string}
         * @param errorHandler {function}
         */
        this.fetchExtensionMethods = (0, mobx_1.flow)(function* (errorHandler) {
            try {
                this.apiState = API_STATE_1.default.LOADING;
                this.data = [];
                // make the api call
                const response = yield (0, getExtensionPaymentMethods_1.default)();
                // if api response have data
                this.onSuccess(response);
            }
            catch (err) {
                this.callErrorHandler(err, errorHandler);
            }
        });
        /**
         * on success callback
         * @param data
         */
        this.onSuccess = (data) => {
            this.data = data;
            this.apiState = API_STATE_1.default.SUCCESS;
        };
        /**
         * on error callback
         * @param err
         * @param errorHandler
         */
        this.callErrorHandler = (err, errorHandler) => {
            // when a request is cancelled, Axios promise is rejected
            if (err.response) {
                const errResponse = err.response;
                // invoke the callback
                if (errorHandler) {
                    errorHandler(errResponse);
                }
            }
        };
        /**
         * Map initial state to store state
         * @param initialState
         */
        this.updateInitialState = (initialState) => {
            (0, mapInitialStateToStoreState_1.default)(this, initialState);
        };
        this.$env = $env;
        this.updateInitialState(initialState);
    }
    /**
     * Returns the loading status
     * @returns {Boolean}
     */
    get isLoading() {
        return this.apiState === API_STATE_1.default.LOADING;
    }
    /**
     * Returns true if API fetch was success
     * @returns {Boolean}
     */
    get isSuccess() {
        return this.apiState === API_STATE_1.default.SUCCESS;
    }
    /**
     * Returns true if API fetch has failed
     * @returns {Boolean}
     */
    get hasFailed() {
        return this.apiState === API_STATE_1.default.FAILED;
    }
    /**
     * Returns formatted Payment method List
     * @returns {Array<PaymentMethodType>}
     */
    get paymentMethods() {
        return (0, map_1.default)(this.data, (paymentMethod) => (0, paymentMethodFactory_1.default)(paymentMethod));
    }
    /**
     * Returns true if payment method has Apple pay
     * @returns {Boolean}
     */
    get hasApplePay() {
        return !!(0, find_1.default)(this.paymentMethods, (paymentMethod) => {
            const name = (0, get_1.default)(paymentMethod, 'name', '');
            return name === PAYMENT_METHOD_TYPE_1.default.APPLE_PAY;
        });
    }
    /**
     * Returns true if payment method has Card
     * @returns {Boolean}
     */
    get hasCard() {
        return !!(0, find_1.default)(this.paymentMethods, (paymentMethod) => {
            const name = (0, get_1.default)(paymentMethod, 'name', '');
            return name === PAYMENT_METHOD_TYPE_1.default.CARD;
        });
    }
    /**
     * Returns true if payment method has Cash
     * @returns {Boolean}
     */
    get hasCash() {
        return !!(0, find_1.default)(this.paymentMethods, (paymentMethod) => {
            const name = (0, get_1.default)(paymentMethod, 'name', '');
            return name === PAYMENT_METHOD_TYPE_1.default.CASH;
        });
    }
    /**
     * Returns payment method name with comma seperated for ex: 'CARD, APPLE_PAY, CASH'
     * @returns {string}
     */
    get paymentMethodName() {
        return (0, map_1.default)(this.paymentMethods, (paymentMethod) => (0, get_1.default)(paymentMethod, 'name', '')).join(', ');
    }
    /**
     * Returns filtered Payment method List except 'APPLE_PAY' method
     * @returns {Array<PaymentMethodType>}
     */
    get filteredPaymentMethods() {
        const methodsCount = (0, size_1.default)(this.paymentMethods);
        const hasApplePay = (0, find_1.default)(this.paymentMethods, (paymentMethod) => {
            const name = (0, get_1.default)(paymentMethod, 'name', '');
            return name === PAYMENT_METHOD_TYPE_1.default.APPLE_PAY;
        });
        // if api returns only APPLE_PAY method then we need to show both payment method.
        if (methodsCount === 1 && hasApplePay) {
            return paymentMethod_mock_1.mockData;
        }
        // filter out apple pay option
        return (0, filter_1.default)(this.paymentMethods, (paymentMethod) => {
            const name = (0, get_1.default)(paymentMethod, 'name', '');
            return name !== PAYMENT_METHOD_TYPE_1.default.APPLE_PAY;
        });
    }
}
__decorate([
    mobx_1.observable
], PaymentMethodStore.prototype, "data", void 0);
__decorate([
    mobx_1.observable
], PaymentMethodStore.prototype, "apiState", void 0);
__decorate([
    mobx_1.computed
], PaymentMethodStore.prototype, "isLoading", null);
__decorate([
    mobx_1.computed
], PaymentMethodStore.prototype, "isSuccess", null);
__decorate([
    mobx_1.computed
], PaymentMethodStore.prototype, "hasFailed", null);
__decorate([
    mobx_1.computed
], PaymentMethodStore.prototype, "paymentMethods", null);
__decorate([
    mobx_1.computed
], PaymentMethodStore.prototype, "hasApplePay", null);
__decorate([
    mobx_1.computed
], PaymentMethodStore.prototype, "hasCard", null);
__decorate([
    mobx_1.computed
], PaymentMethodStore.prototype, "hasCash", null);
__decorate([
    mobx_1.computed
], PaymentMethodStore.prototype, "paymentMethodName", null);
__decorate([
    mobx_1.computed
], PaymentMethodStore.prototype, "filteredPaymentMethods", null);
__decorate([
    mobx_1.action.bound
], PaymentMethodStore.prototype, "onSuccess", void 0);
__decorate([
    mobx_1.action.bound
], PaymentMethodStore.prototype, "callErrorHandler", void 0);
__decorate([
    mobx_1.action.bound
], PaymentMethodStore.prototype, "updateInitialState", void 0);
exports.default = PaymentMethodStore;
